export const KEYS = { ENTER: "Enter", TAB: "Tab" };
